<template>
  <div class="upload-component ">
    <div class="upload-panel message-panel">
      <div class="close-box small" v-on:click="handleClose"></div>
      <div class="spacey-panel">
        <div class="heading">Upload File</div>
        <div>
          <input type="file" name="file" ref="fileInput" />
        </div>
        <div class="flex-middle">
          <div>
            <label for="naming">Naming method:</label>
          </div>
          <div>
            <select name="naming" v-model="naming">
              <option value="random">Assign random name</option>
              <option value="original">Use upload filename</option>
              <option value="user">Type a new name</option>
            </select>
          </div>
        </div>
        <div v-show="naming === 'user'" class="flex-middle">
          <div><label for="filename">Filename</label></div>
          <div><input type="text" name="filename" size="50" v-model="userFilename" /></div>
        </div>
        <div>
          <input type="checkbox" name="thumbs" v-model="thumbs"> <label for="thumbs">Generate thumbnails</label>
        </div>
        <div>
          <label for="foldername">In folder (optional)</label>
          <input type="text" name="foldername" size="50" v-model="foldername" />
        </div>
      </div>
      <div>
        <small-button v-on:click="handleUpload" :loading="this.loading">Upload</small-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    page: String,
    item: String
  },
  data () {
    return {
      loading: false,
      showEditor: false,
      naming: 'random',
      userFilename: '',
      thumbs: false,
      origFilename: '',
      foldername: ''
    }
  },
  methods: {
    handleClose () {
      this.$emit('close', true)
    },
    handleUpload: async function () {
      let files = this.$refs.fileInput.files
      if (files.length < 1) {
        this.$k.messageBox('No files to upload.')
        return
      }
      const reader = new FileReader();
      this.loading = true
      reader.onload = () => {
          const b64 = btoa(reader.result);
          this.origFilename = files[0].name
          this.doUpload(b64)
      }
      reader.readAsBinaryString(files[0]);
    },
    doUpload: async function (b64) {
      let info = {
        file: b64,
        origFilename: this.origFilename,
        thumbs: this.thumbs,
        naming: this.naming,
        foldername: this.foldername,
        filename: this.userfilename
      }
      let upload = await this.$k.uploadFile(info)
      this.loading = false
      if(upload.url) {
        this.$k.messageBox('Url', upload.url)
      }
      else {
        this.$k.messageBox('Error', upload.error)
      }
      
    }
  }
}
</script>

<style>
.upload-component{
  position:fixed;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
  z-index:1000;
}
.upload-button {
  width:20px;
  height:20px;
  background-color:#a7aba1;
  background-image:url('../../assets/img/upload-white.svg');
  background-position: center center;
}

.spacey-panel div{
  margin:12px 0;
}

.upload-button:hover{
  background-color:#ce0e2d;
}

.spacey-panel label{
  color:#000;
}

.heading{
  font-size:24px;
  font-weight:500;
}

.upload-panel.message-panel{
  z-index:4000;
}
</style>
